import { render } from "./practice_results.vue?vue&type=template&id=5b2afd53"
import script from "./practice_results.vue?vue&type=script&lang=js"
export * from "./practice_results.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_FEproject\\aplikovanainformatika.sk\\zoneai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__